// Turn construction for the live message stream and the history hydrate.
// Pure so it is unit-testable without a DOM.

import type { ChatMedia, ChatTurn, Component } from './protocol.ts';

export type StreamEnvelope = {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string | null;
  createdAt: string;
  components?: Component[] | null;
  // CL-298: a signed URL for an image the message carries (the pairing picture).
  media?: ChatMedia | null;
};

const validMedia = (m: ChatMedia | null | undefined): ChatMedia | undefined =>
  m && typeof m.url === 'string' && typeof m.mime === 'string' ? m : undefined;

/** A stream/replay envelope → the bubble. Assistant bubbles carry their image. */
export const turnFromStream = (parsed: StreamEnvelope): ChatTurn => {
  const media = validMedia(parsed.media);
  return parsed.role === 'user'
    ? {
        role: 'user',
        id: parsed.id,
        text: parsed.content ?? '',
        createdAt: parsed.createdAt,
        ...(media ? { media } : {}),
      }
    : {
        role: 'assistant',
        id: parsed.id,
        text: parsed.content ?? '',
        components: Array.isArray(parsed.components) ? parsed.components : null,
        event: null,
        createdAt: parsed.createdAt,
        ...(media ? { media } : {}),
      };
};

/** The image a bubble carries, whichever side it is on. */
export const mediaOf = (turn: ChatTurn): ChatMedia | undefined =>
  'media' in turn ? turn.media : undefined;
